import { Box, Card, CardContent, Typography, Table, TableBody, TableCell, TableHead, TableRow, Skeleton, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import axios from "axios";

const formatAmount = (amount = 0) => `₹ ${amount.toLocaleString("en-IN")}`;
const formatDate = (dateVal) => {
	if (!dateVal) return "-";
	if (typeof dateVal === "object" && dateVal.value) {
		const d = new Date(dateVal.value);
		return !isNaN(d.getTime()) ? d.toLocaleDateString("en-GB") : "-";
	}
	return dateVal;
};

const OthersBreakdown = ({ startDate, endDate, open }) => {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({
		ledgerOther: [],
		bankStatement: [],
	});

	useEffect(() => {
		if (!open) return;

		const fetchOthers = async () => {
			setLoading(true);
			try {
				const { data: responseData } = await axios.post("/api/pos_reco/get-others-ledger-bankstatement-breakdown", {
					start_date: startDate,
					end_date: endDate,
				});
				setData({
					ledgerOther: responseData?.ledgerOther || [],
					bankStatement: responseData?.bankStatement || [],
				});
			} catch (err) {
				console.error(err);
			} finally {
				setLoading(false);
			}
		};

		fetchOthers();
	}, [open, startDate, endDate]);

	const renderTable = (title, rows) => (
		<Card variant="outlined" sx={{ height: "100%", borderRadius: 2 }}>
			<Box sx={{ bgcolor: "#f5f5f5", px: 2, py: 1.5, borderBottom: "1px solid #e0e0e0" }}>
				<Typography variant="subtitle2" fontWeight={600}>
					{title}
				</Typography>
			</Box>
			<CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
				{rows.length === 0 ? (
					<Box p={3} textAlign="center">
						<Typography variant="body2" color="text.secondary">
							No transactions found.
						</Typography>
					</Box>
				) : (
					<Box sx={{ maxHeight: 400, overflow: "auto" }}>
						<Table size="small" stickyHeader>
							<TableHead>
								<TableRow>
									<TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", bgcolor: "#fff" }}>Date</TableCell>
									<TableCell sx={{ fontWeight: 600, fontSize: "0.75rem", bgcolor: "#fff" }}>Narration</TableCell>
									<TableCell align="right" sx={{ fontWeight: 600, fontSize: "0.75rem", bgcolor: "#fff" }}>
										Amount
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{rows.map((row, idx) => (
									<TableRow key={idx} hover>
										<TableCell sx={{ fontSize: "0.75rem" }}>{formatDate(row.date)}</TableCell>
										<TableCell sx={{ fontSize: "0.75rem", maxWidth: 200, wordBreak: "break-word" }}>
											{row.narration}
										</TableCell>
										<TableCell align="right" sx={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
											{formatAmount(row.amount)}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</Box>
				)}
			</CardContent>
		</Card>
	);

	return (
		<Box sx={{ mt: 2 }}>
			{loading ? (
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
					</Grid>
					<Grid item xs={12} md={6}>
						<Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
					</Grid>
				</Grid>
			) : (
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						{renderTable("Ledger (Others)", data.ledgerOther)}
					</Grid>
					<Grid item xs={12} md={6}>
						{renderTable("Bank Statement (Others)", data.bankStatement)}
					</Grid>
				</Grid>
			)}
		</Box>
	);
};

export default OthersBreakdown;
